import { useState } from 'react'
import { CircularProgress } from '@mui/material'
import Button from '@mui/material/Button'
import { styled } from '@mui/styles'
import { spacing } from '@mui/system'
import { func, any } from 'prop-types'
import { colors } from '@global/constants'

// The only caveat here is that if you want the spinner to show, the function you pass to the onClick handler must return a promise.

export const CvsButton = styled(({ onClick = () => {}, children = null, ...props }) => {
  const [loading, setLoading] = useState(false)

  return (
    <Button
      variant="contained"
      sx={{
        boxShadow: 'none',
        '&:hover, &:focus, &:active': {
          boxShadow: 'none',
        },
      }}
      onClick={e => {
        if (!loading) {
          const resp = onClick(e)
          if (resp instanceof Promise) {
            setLoading(true)
            resp
              .then(() => {
                setLoading(false)
              })
              .catch(() => {
                setLoading(false)
              })
          }
          return resp
        }
        return null
      }}
      {...props}
    >
      {loading && (
        <CircularProgress
          size={15}
          sx={{ color: colors.white, marginLeft: '-10px', marginRight: '10px' }}
        />
      )}
      {children}
    </Button>
  )
})(spacing)

CvsButton.propTypes = {
  onClick: func,
  children: any,
}
